import { toast } from 'react-toastify';
import { CopyIcon, TickIcon } from '../../theme/SvgIcons';
import PropTypes from 'prop-types';
import { useState } from 'react';

const CopyToClipboard = ({ valueToCopy }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(valueToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch (err) {
      setCopied(false);
      console.error('Failed to copy!', err);
      toast.error('Failed to copy!');
    }
  };

  return (
    <div onClick={handleCopy} style={{ cursor: 'pointer', position: 'relative' }}>
      <div style={{ position: 'relative', width: '20px', height: '20px' }}>
        {copied ? <TickIcon /> : <CopyIcon />}
      </div>
      {copied && (
        <div
          style={{
            position: 'absolute',
            top: '-30px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#333',
            color: '#fff',
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            whiteSpace: 'nowrap',
            zIndex: 10
          }}>
          Copied
        </div>
      )}
    </div>
  );
};

CopyToClipboard.propTypes = {
  valueToCopy: PropTypes.string
};

export default CopyToClipboard;
